export default __webpack_public_path__ + "static/media/modal1_headerImage_es.914a71b0.svg";